import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function EcoIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      ariaHidden="true"
    >
      <path d="m19.7402 3.59998c.1734.00006.3373.06683.4699.18925.1274.13271.1988.31149.1887.49512-.0053.09496-.1284 2.32622-.7711 5.10762-.3828 1.64413-.8677 3.13523-1.4443 4.43733-.7351 1.6545-1.6181 3.0085-2.6338 4.0248-1.2557 1.2562-2.9259 1.9458-4.7022 1.9459-1.2597-.0002-2.47856-.3533-3.52733-1.0114.20493-.403.4202-.7999.64512-1.1906.84964.5528 1.84653.8518 2.88221.852 1.4193-.0001 2.7454-.5483 3.7471-1.5504.8713-.8718 1.6694-2.0753 2.3549-3.6182.5364-1.2114.9964-2.6195 1.3634-4.19588.2975-1.28786.4782-2.45291.5866-3.32109-5.0105 2.3647-9.19021 6.19917-11.98128 10.94937l.00058.0012c-.0445.0758-.08865.1517-.13242.2279-.03425.0596-.06814.1195-.10195.1793-.15332.2718-.30214.5465-.44649.8239l-.00117-.0012c-.41443.7963-.79105 1.6154-1.12734 2.4551h-1.44844c2.44935-6.4655 7.15821-11.8188 13.16371-15.09612-.5893.09912-1.2378.2248-1.9202.38262l-.0017.00058c-1.5703.36109-2.9781.82568-4.1912 1.36348-1.54146.6856-2.74413 1.48451-3.61526 2.35606-1.18191 1.18278-1.69014 2.80188-1.50996 4.35938-.35168.5216-.6886 1.0543-1.00781 1.5984-.82573-2.3463-.29265-5.0556 1.56269-6.91228 1.01575-1.01624 2.36932-1.90015 4.02304-2.63554 1.3015-.57701 2.7927-1.06763 4.4361-1.44551 2.779-.64273 5.0082-.76576 5.1399-.77109z" fill={color} />
    </SVGWrapper>

  );
}

export default EcoIcon;
